/* -----------------------------------------------------------------------------------------------------
  - Created: [30-01-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains site form for add/edit/view
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/joy';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import { BsFillBuildingsFill } from "react-icons/bs";
import { FaHashtag } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { GrUserWorker } from "react-icons/gr";
import { FaRegFolderClosed } from "react-icons/fa6";
import { get_project_with_pagination } from '../../../../config/Worksite/projectApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { statusOptions } from '../../../../utils/constants';
import { get_worksite_with_pagination } from '../../../../config/Worksite/siteApis';
import { get_workforce_with_pagination } from '../../../../config/Resource/workforceApis';
import CustomTooltip from '../../../../Components/custom_components/CustomTooltip/CustomTooltip';
import './WorksiteFormStyle.css';
import CustomCheckbox from '../../../../Components/custom_components/CustomCheckbox/CustomCheckbox';


function WorksiteForm({ handleSave, isButtonDisabled, id, formValues, isDisabled }) {

    const [projectListing, SetProjectListing] = useState([]);
    const [siteListing, setSiteListing] = useState([]);
    const [workforceListing, setWorkforceListing] = useState([]);

    const [checked, setChecked] = useState(false); //chedked true the parent id not 0

    // FETCH PROJECTS
    const fetchProjects = async () => {
        try {
            const params = {
                status: isDisabled ? '' : 1 //1MEANS ACTIVE when isdisable true mens view modal. need to get all the projcts otherwise list active prjcts
            }
            const response = await get_project_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.ProjectName,
                    value: item?.ProjectID
                }));

                // Set the transformed data to the state
                SetProjectListing(transformedData || []);
            } else {
                SetProjectListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetProjectListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const params = { //FOR GET Active Sites ONLY LIST
                status: isDisabled ? '' : 1,
                mainSite: 0,
                project: formik?.values?.WD_ProjectId
            }
            const response = await get_worksite_with_pagination(params);

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID
                }));

                // Remove the item that matches the id from props
                const filteredData = transformedData?.filter(item => item.value !== id);

                // Set the filtered data to the state
                setSiteListing(filteredData || []);
            } else {
                setSiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setSiteListing([]);
        }
    };

    // FETCH WORKFORCES 
    const fetchWorkForces = async () => {
        try {
            const params = { //FOR GET SUPERVISIOR ONLY LIST
                RoleID: 2,
                status: isDisabled ? '' : 1
            }
            const response = await get_workforce_with_pagination(params);

            if (response?.status === "success") {

                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.UD_name,
                    value: item?.UD_ID
                }));

                // Set the transformed data to the state
                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };
    // FOR GET LIST
    useEffect(() => {

        fetchProjects();
        fetchWorkForces()
    }, []);


    const formik = useFormik({
        initialValues: formValues,
        enableReinitialize: true,
        validationSchema: Yup.object({
            WD_WorksiteName: Yup.string().required('Name is required'),
            // WD_SiteCode: Yup.string().required('Code is required'),
            WD_SiteCode: Yup.string().required('Shortcode is required')
                .min(4, 'Shortcode Code must be at least 4 characters')
                .max(15, 'Shortcode must not exceed 15 characters.'),
            WD_Location: Yup.string().required('Location is required'),
            WD_Owner: Yup.array().min(1, 'At least one Supervisor must be selected').required('Assigned Supervisor are required'),
            // WD_Description: Yup.string().optional(),
            // Conditionally required based on 'checked'
            WD_ParentWorksiteId: checked ? Yup.string().required('Worksite is required') : Yup.string(),
            WD_ProjectId: Yup.string().required('Project is required'),
        }),
        onSubmit: (values) => {
            const params = {
                ...values,
                WD_ParentWorksiteId: checked ? values?.WD_ParentWorksiteId : 0, //pass 0 when checkbox unselected
            };
            handleSave(params, id)
        },

    });

    // Reset handler
    const handleReset = () => {
        // Reset Formik values
        setChecked(false)
        formik.resetForm({
            values: {
                WD_WorksiteName: '',
                WD_SiteCode: '',
                WD_Location: '',
                WD_Owner: [],
                WD_Description: '',
                WD_ParentWorksiteId: '', // Reset main_site here
                project: '',
                WD_status: 1,
                WD_ProjectId: ''
            }
        });

        // Reset warning messages
        formik.setTouched({
            WD_WorksiteName: false,
            WD_SiteCode: false,
            WD_Location: false,
            WD_Owner: false,
            WD_ParentWorksiteId: false,
            project: false,
            WD_status: false,
            WD_ProjectId: false,

        });
    };

    // FOR HANDLE THE CHECK BOX OF MAIN SITE OR NOT
    const handleChange = (e) => {
        const isChecked = e.target.checked;
        setChecked(isChecked);
        if (isChecked) {
            formik.setFieldValue("WD_ParentWorksiteId", '');
        }
    };

    useEffect(() => {
        setChecked(Boolean(formValues?.WD_ParentWorksiteId && formValues?.WD_ParentWorksiteId !== "0"))
    }, [formValues])

    // GET SITE CORRESPONDING PROJECTS
    useEffect(() => {
        if (checked) {
            fetchSites()
        }

    }, [checked, formik?.values?.WD_ProjectId])



    return (
        <div className="worksiteform-form-container">
            <Grid container columnSpacing={3}>
                {/* checkbox */}
                <Grid item xs={12} mb={2}>
                    <CustomCheckbox
                        label="Sub Site"
                        checked={checked}
                        onChange={handleChange}
                        disabled={isDisabled}
                    />
                </Grid>
                {/* Project */}
                <Grid item xs={12} md={6}>
                    <div className="worksiteform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Project<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="WD_ProjectId"
                                placeholder="Select project"
                                options={projectListing}
                                value={projectListing?.find(option => option?.value === formik?.values?.WD_ProjectId) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("WD_ProjectId", selectedOption ? selectedOption.value : "");
                                    formik.setFieldValue("WD_ParentWorksiteId", ""); // clear main site when project changes
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.WD_ProjectId && Boolean(formik.errors.WD_ProjectId)}
                                helperText={formik.touched.WD_ProjectId && formik.errors.WD_ProjectId}
                                StartIcon={<FaRegFolderClosed />}
                                isDisabled={isDisabled}
                                isClearable={false}
                                isMulti={false} // Set to false for single-select
                                width="100%"
                            />

                        </div>
                    </div>
                </Grid>

                {/* Main Site */}
                {checked && <Grid item xs={12} md={6}>
                    <div className="worksiteform-mid-form-container">

                        <div className="label-container">
                            <span className="label">Main Site<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">

                            <CustomSelectDropdown
                                name="WD_ParentWorksiteId"
                                placeholder="Select main site"
                                options={siteListing}
                                value={siteListing?.find(option => option?.value === formik?.values?.WD_ParentWorksiteId) || ''}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("WD_ParentWorksiteId", selectedOption ? selectedOption.value : '');
                                }}

                                onBlur={formik.handleBlur}
                                error={formik.touched.WD_ParentWorksiteId && Boolean(formik.errors.WD_ParentWorksiteId)}
                                helperText={formik.touched.WD_ParentWorksiteId && formik.errors.WD_ParentWorksiteId}
                                StartIcon={<FaLocationDot />}
                                isDisabled={isDisabled}
                                isMulti={false} // Set to false for single-select
                                width="100%"
                                isClearable={false}
                            />

                        </div>
                    </div>
                </Grid>}


                {/* Worksite Name */}
                <Grid item xs={12} md={6}>
                    <CustomTooltip title={isDisabled ? formik.values.WD_WorksiteName : ''}>
                        <div className="worksiteform-mid-form-container">

                            <div className="label-container">
                                <span className="label"> Name<span className="label_required_remark">*</span></span>
                            </div>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="WD_WorksiteName"
                                    name="WD_WorksiteName"
                                    placeholder="Enter worksite name"
                                    value={formik.values.WD_WorksiteName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WD_WorksiteName && Boolean(formik.errors.WD_WorksiteName)}
                                    helperText={formik.touched.WD_WorksiteName && formik.errors.WD_WorksiteName}
                                    StartIcon={BsFillBuildingsFill}
                                    isDisabled={isDisabled}
                                />
                            </div>
                        </div>
                    </CustomTooltip>
                </Grid>

                {/* Worksite Code */}
                <Grid item xs={12} md={6}>
                    <div className="worksiteform-mid-form-container">

                        <div className="label-container">
                            <span className="label"> Code<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextFieldWithIcon
                                id="WD_SiteCode"
                                name="WD_SiteCode"
                                placeholder="Enter code"
                                value={formik.values.WD_SiteCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.WD_SiteCode && Boolean(formik.errors.WD_SiteCode)}
                                helperText={formik.touched.WD_SiteCode && formik.errors.WD_SiteCode}
                                isDisabled={isDisabled}
                                maxLength={15}
                            />
                            <span className="example-field-label">eg: ABCD</span>

                        </div>
                    </div>
                </Grid>

                {/* Equipment Name */}
                <Grid item xs={12} md={6}>
                    <div className="equipmentform-mid-form-container">
                        <div className="label-container">
                            <span className="label">Location<span className="label_required_remark">*</span></span>
                        </div>
                        <CustomTooltip title={isDisabled ? formik.values.WD_Location : ''}>
                            <div className="custom-textfield-container">
                                <CustomTextFieldWithIcon
                                    id="WD_Location"
                                    name="WD_Location"
                                    placeholder="Enter location"
                                    value={formik.values.WD_Location}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WD_Location && Boolean(formik.errors.WD_Location)}
                                    helperText={formik.touched.WD_Location && formik.errors.WD_Location}
                                    StartIcon={BsFillBuildingsFill}
                                    isDisabled={isDisabled}

                                />
                            </div>
                        </CustomTooltip>

                    </div>
                </Grid>

                {/* Assigned Employees */}
                <Grid item xs={12} md={6}>
                    <div className="worksiteform-mid-form-container">

                        <div className="label-container">
                            <span className="label">Site Supervisor<span className="label_required_remark">*</span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomSelectDropdown
                                name="WD_Owner"
                                placeholder="Select supervisor"
                                options={workforceListing}
                                value={workforceListing?.filter(option => formik.values.WD_Owner?.includes(option.value))}
                                onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions.map(option => option.value);
                                    formik.setFieldValue("WD_Owner", selectedValues);

                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.WD_Owner && Boolean(formik.errors.WD_Owner)}
                                helperText={formik.touched.WD_Owner && formik.errors.WD_Owner}
                                isDisabled={isDisabled}

                                isMulti={true} // Set to true for multi-select
                                width="100%"
                                StartIcon={<GrUserWorker />}
                            />

                        </div>
                    </div>
                </Grid>

                {id && <Grid item xs={12} md={6}>
                    <div className="label-container">
                        <span className="label">Status <span className='label_required_remark'>*</span></span>
                    </div>
                    <div className="custom-textfield-container">

                        <CustomSelectDropdown
                            name="WD_status"
                            placeholder="Select status"
                            options={statusOptions}
                            value={statusOptions?.find(option => option?.value === formik?.values?.WD_status) || ""}
                            onChange={(selectedOption) => {
                                formik.setFieldValue("WD_status", selectedOption ? selectedOption.value : "");
                            }}
                            onBlur={formik.handleBlur}
                            error={formik.touched.WD_status && Boolean(formik.errors.WD_status)}
                            helperText={formik.touched.WD_status && formik.errors.WD_status}
                            StartIcon={<FaHashtag />}
                            isMulti={false} // Set to false for single-select
                            width="100%"
                            isDisabled={isDisabled}
                            isClearable={false}
                        />
                    </div>
                </Grid>}

                <Grid item xs={12}>
                    <div className="worksiteform-mid-form-container">
                        {/* Description */}
                        <div className="label-container">
                            <span className="label">Description<span className='label_required_remark'></span></span>
                        </div>
                        <div className="custom-textfield-container">
                            <CustomTextArea
                                id="WD_Description"
                                name="WD_Description"
                                placeholder="Enter description"
                                value={formik.values.WD_Description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                rows={5}
                                isDisabled={isDisabled}

                            />
                        </div>
                    </div>
                </Grid>


            </Grid>

            {/* Action Buttons */}
            {!isDisabled && <div className="form-bottom-action-buttons-container">
                <ActionButton onClick={handleReset} label="Reset" btnType="outlined" />
                <ActionButton
                    onClick={formik.handleSubmit}
                    btnDisable={isButtonDisabled}
                    label="Save " btnType="primary" />
            </div>}
        </div>
    );
}

export default WorksiteForm;
